export const baseUrls = {
  DEVELOPMENT: {
    USER_SERVICE: "https://user-api-qa.worksimpli.io",
    DOCBUILDER_SERVICE: "https://docbuilder-api-qa.worksimpli.io/api/v1/docbuilder/",
    DOCPARSER_SERVICE: "https://docbuilder-api-qa.worksimpli.io/api/v1/docparser/",
    EVENT_SERVICE: "https://event-api-qa.worksimpli.io",
    AUTH_SERVICE: "https://auth-api-qa.worksimpli.io/api/",
    DOC_META_CONTENT_SERVICE: "https://docmetacontent-api-qa.worksimpli.io/api/v1/",
    PAYMENT_SERVICE: "https://payment-api-qa.worksimpli.io/api/v1/",
    ORDER_SERVICE: "https://order-api-qa.worksimpli.io/api/",
    PAYMENT_ORCHESTRATION_SERVICE: "https://paymentorchestration-qa.worksimpli.io/api/v1/",
    SINGLE_SIGN_ON_PDFSIMPLI: "https://test-app.pdfsimpli.com/sso/",
    SINGLE_SIGN_ON_SIGNSIMPLI: "https://test.signsimpli.com/sso/",
    SINGLE_SIGN_ON_RESUMEBUILD: "https://test.resumebuild.com/app/",
    SINGLE_SIGN_ON_LEGASLSIMPLI: "https://test.legalsimpli.com/app/template/sso",
    SINGLE_SIGN_ON_DASHBOARD: "https://test.legalsimpli.com/app/",
    SIGNSIMPLI_URL: "https://test.signsimpli.com",
    PDFSIMPLI_URL: "https://test-app.pdfsimpli.com",
    RESUMEBUILD_URL: "https://test.resumebuild.com",
    DASHBOARD_ORCH_SERVICE: "https://dashboardorch-qa.worksimpli.io",
    TRUSTPILOT_SERVICE: "",
    ABTEST_SERVICE: "https://abtest-api-qa.worksimpli.io",
    DOC_EDITOR_SERVICE: "https://doceditor-api-qa.worksimpli.io/",
  },
  QA: {
    USER_SERVICE: "https://user-api-qa.worksimpli.io",
    DOCBUILDER_SERVICE: "https://docbuilder-api-qa.worksimpli.io/api/v1/docbuilder/",
    DOCPARSER_SERVICE: "https://docbuilder-api-qa.worksimpli.io/api/v1/docparser/",
    EVENT_SERVICE: "https://event-api-qa.worksimpli.io",
    AUTH_SERVICE: "https://auth-api-qa.worksimpli.io/api/",
    DOC_META_CONTENT_SERVICE: "https://docmetacontent-api-qa.worksimpli.io/api/v1/",
    PAYMENT_SERVICE: "https://payment-api-qa.worksimpli.io/api/v1/",
    ORDER_SERVICE: "https://order-api-qa.worksimpli.io/api/",
    PAYMENT_ORCHESTRATION_SERVICE: "https://paymentorchestration-qa.worksimpli.io/api/v1/",
    SINGLE_SIGN_ON_PDFSIMPLI: "https://test-app.pdfsimpli.com/sso/",
    SINGLE_SIGN_ON_SIGNSIMPLI: "https://test.signsimpli.com/sso/",
    SINGLE_SIGN_ON_RESUMEBUILD: "https://test.resumebuild.com/app/",
    SINGLE_SIGN_ON_LEGASLSIMPLI: "https://test.legalsimpli.com/app/template/sso",
    SINGLE_SIGN_ON_DASHBOARD: "##LSTemplateAPP_BaseUrl##",
    SIGNSIMPLI_URL: "https://test.signsimpli.com",
    PDFSIMPLI_URL: "https://test-app.pdfsimpli.com",
    RESUMEBUILD_URL: "https://test.resumebuild.com",
    DASHBOARD_ORCH_SERVICE: "https://dashboardorch-qa.worksimpli.io",
    TRUSTPILOT_SERVICE: "",
    ABTEST_SERVICE: "https://abtest-api-qa.worksimpli.io",
    DOC_EDITOR_SERVICE: "https://doceditor-api-qa.worksimpli.io/",
  },
  STAGING: {
    USER_SERVICE: "https://user-api.worksimpli.io",
    DOCBUILDER_SERVICE: "https://docbuilder-api.worksimpli.io/api/v1/docbuilder/",
    DOCPARSER_SERVICE: "https://docbuilder-api.worksimpli.io/api/v1/docparser/",
    EVENT_SERVICE: "https://event-api.worksimpli.io",
    AUTH_SERVICE: "https://auth-api.worksimpli.io/api/",
    DOC_META_CONTENT_SERVICE: "https://docmetacontent-api.worksimpli.io/api/v1/",
    PAYMENT_SERVICE: "https://payment-api.worksimpli.io/api/v1/",
    ORDER_SERVICE: "https://order-api.worksimpli.io/api/",
    PAYMENT_ORCHESTRATION_SERVICE: "https://paymentorchestration-api.worksimpli.io/api/v1/",
    SINGLE_SIGN_ON_PDFSIMPLI: "https://pdfsimpli.com/sso/",
    SINGLE_SIGN_ON_SIGNSIMPLI: "https://signsimpli.com/sso/",
    SINGLE_SIGN_ON_DASHBOARD: "https://staging.legalsimpli.com/app/",
    SIGNSIMPLI_URL: "https://staging.signsimpli.com",
    PDFSIMPLI_URL: "https://staging.pdfsimpli.com",
    RESUMEBUILD_URL: "https://staging.resumebuild.com",
    DASHBOARD_ORCH_SERVICE: "https://dashboardorch-api.worksimpli.io",
    TRUSTPILOT_SERVICE: "https://www.trustpilot.com/evaluate/embed/resumebuild.com",
    ABTEST_SERVICE: "https://abtest-api.worksimpli.io",
    DOC_EDITOR_SERVICE: "https://doceditor-api.worksimpli.io/",
  },
  PRODUCTION: {
    USER_SERVICE: "https://user-api.worksimpli.io",
    DOCBUILDER_SERVICE: "https://docbuilder-api.worksimpli.io/api/v1/docbuilder/",
    DOCPARSER_SERVICE: "https://docbuilder-api.worksimpli.io/api/v1/docparser/",
    EVENT_SERVICE: "https://event-api.worksimpli.io",
    AUTH_SERVICE: "https://auth-api.worksimpli.io/api/",
    DOC_META_CONTENT_SERVICE: "https://docmetacontent-api.worksimpli.io/api/v1/",
    PAYMENT_SERVICE: "https://payment-api.worksimpli.io/api/v1/",
    ORDER_SERVICE: "https://order-api.worksimpli.io/api/",
    PAYMENT_ORCHESTRATION_SERVICE: "https://paymentorchestration-api.worksimpli.io/api/v1/",
    SINGLE_SIGN_ON_PDFSIMPLI: "https://pdfsimpli.com/sso/",
    SINGLE_SIGN_ON_SIGNSIMPLI: "https://signsimpli.com/sso/",
    SINGLE_SIGN_ON_DASHBOARD: "https://legalsimpli.com/app/",
    SIGNSIMPLI_URL: "https://signsimpli.com",
    PDFSIMPLI_URL: "https://pdfsimpli.com",
    RESUMEBUILD_URL: "https://resumebuild.com",
    DASHBOARD_ORCH_SERVICE: "https://dashboardorch-api.worksimpli.io",
    TRUSTPILOT_SERVICE: "https://www.trustpilot.com/evaluate/embed/resumebuild.com",
    ABTEST_SERVICE: "https://abtest-api.worksimpli.io",
    DOC_EDITOR_SERVICE: "https://doceditor-api.worksimpli.io/",
  },
};

//export default baseUrls;
